/**
 * Created by alvinoktavianus on 6/21/17.
 */

import { UPDATE_PAYMENT_STATUS } from './constant'

export function updatePaymentStatus (params) {
  return axios.get(UPDATE_PAYMENT_STATUS, {params, withCredentials: true})
    .then((res) => {
      return Promise.resolve(res)
    })
    .catch((error) => {
      let eobj
      if (error.response) {
        let data = error.response.data
        if (data.errors) {
          eobj = new Error(data.errors)
        } else if (data.message) {
          eobj = new Error(data.message)
        } else {
          eobj = new Error(error.message)
        }
      } else {
        eobj = new Error(error.message)
      }
      return Promise.reject(eobj)
    })
}



// WEBPACK FOOTER //
// ./app/api/billingRedirect/billingRedirect.js